import { createFileRoute } from '@tanstack/react-router';
import { TasksPage } from '@web/modules/tasks/page/tasks-page';
import { parseTasksSearch } from '@web/modules/tasks/page/tasks-search';

export const Route = createFileRoute('/_app/tasks')({
  validateSearch: (search: Record<string, unknown>) => parseTasksSearch(search),
  component: TasksRoute,
});

function TasksRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <TasksPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace })}
    />
  );
}
